import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  FormControlLabel,
  Box,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import ScrollableCard from "./ScrollableCard";
// CSS
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./edit_address_v2.css";
// import { useSwipeable } from 'react-swipeable';
// component
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import PopUp from "../Component/Popup";
import { CustomCarousel } from "../Component/CustomCarousel";
import { CustomInputText } from "../Component/CustomInputText";
import { CustomInputAutocomplete } from "../Component/CustomInputAutocomplete";
import { CustomInputFile } from "../Component/CustomInputFile";
import { Carousel } from "react-responsive-carousel";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";
import FileUploadWithPreviewAddress from "./FileUploadWithPreviewAddress";
import ArticleIcon from "@mui/icons-material/Article";

// services
import {
  getPersonalAddressAPI,
  getPersonalAmphurAPI,
  getPersonalDistrictAPI,
  getPersonalPostalAPI,
  getPersonalProvinceAPI,
  getUserProfileAPI,
  updatePersonalAddressAPI,
  updatePersonalImageAPI,
  getPersonalCountryAPI,
} from "./PersonalService/personalService";
// icon
import icon_address_pin from "../../Icon/address-pin.png";
import Modal from "react-modal";
import InputAdornment from "@mui/material/InputAdornment";
import iconSearch from "../../images/icon-search-2.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { StoreContext } from "../../context/store";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import Skeleton from "react-loading-skeleton";
import greenCheck from "../../Icon/green-circle-check.png";
import { Modal as BootstrapModal } from "react-bootstrap";
import remove from "../../images/remove.png";
import { getPolicyInformationAPI } from "../PolicyList/PolicyListService/policyListService";
import CryptoJS from "crypto-js";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { requestOtpAPI } from "../changePay/changePayService/changePayService";
import { toast, ToastContainer } from "react-toastify";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";
import ContactModal from "../Component/ContactModal";

const EditAddress2 = (props) => {
  let navigate = useNavigate();
  const { dataPolicyActive, updateDataPolicyActive } = useContext(StoreContext);
  const refCarousel = useRef(null);
  const cardRef = useRef(null);
  const [addressStep, setAddressStep] = useState(1);
  const [addressData, setAddressData] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState();
  const [khetOptions, setKhetOptions] = useState();
  const [kwangOptions, setKwangOptions] = useState();
  const [zipOptions, setZipOptions] = useState();
  const [loading, setLoading] = useState(true); // for get profile, get address, save edit, save image
  const [loadingProvince, setLoadingProvince] = useState(true); // for get province
  const [loadingKhet, setLoadingKhet] = useState(false); // for get Khet
  const [loadingKwang, setLoadingKwang] = useState(false); // for get Kwang
  const [loadingZip, setLoadingZip] = useState(false); // for get Zip
  const [loadingCountry, setLoadingCountry] = useState(false); // for get Zip
  const [activeDataModal, setActiveDataModal] = useState(dataPolicyActive ?? 0);
  const [idnvFlag, setIdnvFlag] = useState(
    localStorage.getItem("idnvFlag") || "N"
  );

  const Item = styled("div")(({ theme }) => ({
    // backgroundColor: '#fff',
    // border: '1px solid',
    // borderColor: '#ced7e0',
    // padding: theme.spacing(1),
    borderRadius: "2px",
    // textAlign: 'center',
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
      borderColor: "#444d58",
    }),
  }));

  const [addressNew, setAddressNew] = useState();

  const [place, setPlace] = useState();
  const [addressNumber, setAddressNumber] = useState();
  const [building, setBuilding] = useState();
  const [village, setVillage] = useState();
  const [moo, setMoo] = useState();
  const [soi, setSoi] = useState();
  const [street, setStreet] = useState();
  const [province, setProvince] = useState();
  const [khet, setKhet] = useState();
  const [kwang, setKwang] = useState();
  const [zip, setZip] = useState();
  const [inputErrors, setInputErrors] = useState([]);
  const [addressType, setAddressType] = useState("");
  const [floor, setFloor] = useState();
  const [zone, setZone] = useState();
  const [buildingNo, setBuildingNo] = useState();
  const [country, setCountry] = useState();
  const [project, setProject] = useState();

  // const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [activeIndex, setActiveIndex] = useState(0);
  const [clickPre, setClickPre] = useState();
  const [clickForward, setClickForward] = useState();
  const [currentItem, setCurrentItem] = useState(0);
  const [totalItem, setTotalItem] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [completedModal, setCompletedModal] = useState(false);
  const [searchBasePolicy, setSearchBasePolicy] = useState("");
  const [option, setOption] = useState([]);
  const [toggleImg, setToggleImg] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [selectedIndexes, setSelectedIndexes] = useState([]); // เก็บ index ของ Box ที่ถูกเลือกเป็น array
  const [isChecked, setIsChecked] = useState(false); // สถานะของ CheckAll
  const [listData, setListData] = useState([]); // เก็บข้อมูลที่ถูกเลือก

  const fileDescriptions = ["รูปถ่ายหน้าตรงที่เป็นปัจจุบันคู่บัตรประชาชน"];
  const [files, setFiles] = useState(Array(fileDescriptions.length).fill(null));

  const breakPoints = [{ width: 1, itemsToShow: 1 }];

  const [inputData, setInputData] = useState([{}]);
  const [insureIdCard, setInsureIdCard] = useState(
    localStorage.getItem("customer_id")
  );
  const [dataPolicy, setDataPolicy] = useState([]);
  const [otp, setOtp] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [addrTypeOptions, setAddrTypeOptions] = useState([]);
  const [openContactModal, setOpenContactModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
    setSearchBasePolicy("");
  };

  const handleOpenModal = () => setOpenModal(true);

  const handleSearchBasePolicy = (e) => {
    setSearchBasePolicy(e);
  };

  const handleSelectSearch = (idx) => {
    setActiveDataModal(idx);
  };

  const styleDrive = {
    py: 0,
    width: "100%",
    maxWidth: "auto",
    // borderRadius: 2,
    // border: '1px solid',
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  // ----- function for Step 1 update address -----
  const getPersonalAddress = async () => {
    setLoading(true);
    // setErrorAddressData(false);
    getPersonalAddressAPI()
      .then((res) => {
        setLoading(false);
        if (res.success) {
          let option = [];
          res.payload.map((item, idx) => {
            let dataTmp = {
              label: item.policy_no,
              id: idx,
            };
            option.push(dataTmp);
          });
          setOption(option);
          // setAddressData(data);
          setAddressData(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        // setErrorAddressData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const getProvince = () => {
    setLoadingProvince(true);
    // setErrorProvinceData(false);
    getPersonalProvinceAPI()
      .then((res) => {
        setLoadingProvince(false);
        if (res.success) {
          setProvinceOptions(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingProvince(false);
        // setErrorProvinceData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const getAmphur = (provinceCode) => {
    setLoadingKhet(true);
    // setErrorKhetData(false);
    getPersonalAmphurAPI(provinceCode)
      .then((res) => {
        setLoadingKhet(false);
        if (res.success) {
          setKhetOptions(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingKhet(false);
        // setErrorKhetData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const getCountry = () => {
    setLoadingCountry(true);
    getPersonalCountryAPI()
      .then((res) => {
        setLoadingCountry(false);
        if (res.success) {
          setCountryOptions(res.payload);

          // ตั้งค่า default เป็นประเทศที่ชื่อเป็นภาษาไทย
          const defaultCountry = res.payload.find((c) => c.name === "ไทย");
          if (defaultCountry) {
            setCountry(defaultCountry);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingCountry(false);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  useEffect(() => {
    if (province && province.code) {
      getAmphur(province.code);
    }
  }, [province, listData]);

  useEffect(() => {
    if (addressData.length > 0) {
      setUpselectedAddress(0);
    }
  }, [addressData]);

  useEffect(() => {
    // console.log("useEffect khet/amphur change >>>", khet);
    if (province && khet && khet.code) {
      getDistrict(khet.code);
    }
  }, [khet]);

  const getDistrict = (khetCode) => {
    setLoadingKwang(true);
    // setErrorKwangData(false);
    getPersonalDistrictAPI(khetCode)
      .then((res) => {
        setLoadingKwang(false);
        if (res.success) {
          setKwangOptions(res.payload);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingKwang(false);
        // setErrorKwangData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  const getPostal = (khetCode, kwangCode) => {
    setLoadingZip(true);
    // setErrorZipData(false);
    getPersonalPostalAPI(khetCode, kwangCode)
      .then((res) => {
        setLoadingZip(false);
        if (res.success) {
          setZipOptions(res.payload);
          const activeZip = res.payload.filter((item) => item.active === true);
          setZip(activeZip[0].zip);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoadingZip(false);
        // setErrorZipData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
  };

  useEffect(() => {
    // console.log("useEffect kwang/district change >>>", kwang);
    if (province && khet && khet.code && kwang && kwang.code) {
      getPostal(khet.code, kwang.code);
    }
    // console.log(addressStep);
  }, [kwang]);

  const handleSelectedFile = (e) => {
    const inputFile = e.target.file;
    if (inputFile.length > 0) {
      const updatedFiles = [...files];
      updatedFiles[0] = Object.assign(inputFile[0], {
        preview: URL.createObjectURL(inputFile[0]),
      });
      setFiles(updatedFiles);
    }
  };

  const removeInputError = (inputId) => {
    setInputErrors((errors) => errors.filter((err) => err !== inputId));
  };

  const filteredOptions = option.filter((item) => {
    return searchBasePolicy.trim() === ""
      ? true
      : item.label.toLowerCase().includes(searchBasePolicy.toLowerCase());
  });

  const validateAddress = () => {
    const errors = [];
    if (!place) errors.push("input-place");
    if (!addressNumber) errors.push("input-address-number");
    if (!building) errors.push("input-building");
    if (!village) errors.push("input-village");
    if (!moo) errors.push("input-moo");
    if (!soi) errors.push("input-soi");
    if (!street) errors.push("input-street");
    if (!kwang) errors.push("input-kwang");
    if (!khet) errors.push("input-khet");
    if (!province) errors.push("input-province");
    if (!zip) errors.push("input-zip");
    // if (!project) errors.push("input-project");
    if (!zone) errors.push("input-zone");
    if (!floor) errors.push("input-floor");
    if (!addressType) errors.push("input-address-type");
    if (!buildingNo) errors.push("input-buildin-no");
    if (!country) errors.push("input-country");
    setInputErrors(errors);
    if (errors.length > 0) {
      setToggleImg(false);
      setTextModal("กรุณากรอกข้อมูลให้ครบถ้วน");
      setCompletedModal(true);
    }
    return errors;
  };

  const validateImage = () => {
    let error = false;
    // console.log("file");
    // console.log(file);
    // ตรวจสอบว่า file มีค่า null ทุกตำแหน่งหรือไม่
    const allNull = files.every((item) => item === null);

    if (allNull) {
      // console.log(file);
      error = true;
      setToggleImg(false);
      setTextModal(
        "เพื่อความรวดเร็วในการดำเนินการ โปรดแนบเอกสารให้ครบตามที่บริษัทฯ กำหนดค่ะ"
      );
      setCompletedModal(true);
    }

    if (listData.length === 0) {
      error = true;
      setToggleImg(false);
      setTextModal("กรุณาเลือกกรมธรรม์อย่างน้อย 1 รายการ");
      setCompletedModal(true);
    }

    return error;
  };

  const saveAddressAndImage = () => {
    setLoading(true);
    const errorsAddress = validateAddress();

    if (selectedAddress.length > 0 && errorsAddress.length === 0) {
      let tmpVillage = village !== "" && village !== "-" ? village : "";
      const buildingDescription =
        building === "-" && village === "-"
          ? "-"
          : (building && building !== "-" ? " อาคาร " + building : "-") +
            (tmpVillage && tmpVillage !== "-"
              ? " หมู่บ้าน " + tmpVillage
              : "-");

      const payload = { policies: [] };
      listData.forEach((item) => {
        payload.policies.push({
          policy_no: item.policy_no,
          policy_number: item.id,
          place,
          number: addressNumber,
          building: buildingDescription,
          buildingName: building,
          moo,
          soi,
          street,
          kwang: kwang.name,
          khet: khet.name,
          province: province.name,
          zip,
          addressType: addressType.code,
          floor,
          zone,
          buildingNo,
          village,
          country: country.name,
          address1: item.address1,
          address2: item.address2,
          address3: item.address3,
          address4: item.address4,
          address5: item.address5,
          villageNo: moo,
          otp,
        });
      });

      updatePersonalAddressAPI(payload)
        .then((res) => {
          if (!res.success) {
            console.error("fail Save Address Data", res);
            setLoading(false);
            setToggleImg(false);
            setTextModal(res.payload?.error || "บันทึกที่อยู่ไม่สำเร็จ");
            setCompletedModal(true);
            return;
          }

          // ถ้าไม่ต้องอัปโหลดรูปก็จบที่นี่
          if (idnvFlag !== "N") {
            setLoading(false);
            setToggleImg(true);
            setTextModal(
              "บริษัทได้รับทราบข้อมูลจากท่านแล้ว ท่านจะได้รับ SMS เพื่อดาวน์โหลดเอกสารการเปลี่ยนแปลงภายใน 5 วันทำการ ขอบคุณค่ะ"
            );
            setCompletedModal(true);
            return;
          }

          // === Normalize ให้เป็น Array เสมอ ===
          const toArray = (v) =>
            Array.isArray(v)
              ? v
              : v == null
              ? []
              : typeof v === "string"
              ? v
                  .split(",")
                  .map((x) => x.trim())
                  .filter(Boolean)
              : [v];

          const listIDArr = toArray(res.result?.listID ?? res.result); // รองรับทั้ง res.result และ res.result.listID
          const policyArr = toArray(listData.map((i) => i.policy_no));

          const formData = new FormData();
          (files || []).forEach((file) => formData.append("files", file)); // เผื่อ files เป็น undefined
          formData.append("type", "1"); // FormData ควรเป็น string
          formData.append("codeFile", "1"); // ไม่จำเป็นต้องเป็น array ถ้ามีค่าเดียว
          listIDArr.forEach((id) =>
            formData.append("listID", String(id).trim())
          );
          policyArr.forEach((p) => formData.append("policy", String(p).trim()));

          updatePersonalImageAPI(formData)
            .then((imageRes) => {
              setLoading(false);
              if (imageRes.success) {
                setToggleImg(true);
                setTextModal(
                  "บริษัทได้รับทราบข้อมูลจากท่านแล้ว ท่านจะได้รับ SMS เพื่อดาวน์โหลดเอกสารการเปลี่ยนแปลงภายใน 5 วันทำการ ขอบคุณค่ะ"
                );
                setCompletedModal(true);
              } else {
                console.error("fail Save Image Data", imageRes);
                setToggleImg(false);
                setTextModal(
                  imageRes.payload?.error || "ไม่สามารถบันทึกรูปภาพได้"
                );
                setCompletedModal(true);
              }
            })
            .catch((imageErr) => {
              console.error("Image Save Error: ", imageErr);
              setLoading(false);
              setToggleImg(false);
              setTextModal("ไม่สามารถบันทึกรูปภาพได้");
              setCompletedModal(true);
            });
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
          setToggleImg(false);
          setTextModal("ไม่สามารถบันทึกข้อมูลได้");
          setCompletedModal(true);
        });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log(idnvFlag);
    // check user profile
    setLoading(true);
    getUserProfileAPI()
      .then((res) => {
        setLoading(false);
        if (res.success == "true") {
          if (res.payload.profile == "POS2") {
            // window.location.href = "/home";
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        // setErrorProfileData(true);
        // setOpenErrorWarning(true);
        setToggleImg(false);
        setTextModal("ไม่สามารถเข้าถึงข้อมูลได้");
        setCompletedModal(true);
      });
    // get Personal Address
    getPersonalAddress();
    // get Province data for dropdown
    getProvince();
    getCountry();

    return () => {
      // console.log("useEffect return unmount >>>");
    };
  }, []);

  const renderOptionRow = (val, idx) => {
    const isActive = activeDataModal === idx;

    return (
      <div key={idx}>
        <Row
          onClick={!isActive ? () => handleSelectSearch(idx) : undefined}
          style={isActive ? { backgroundColor: "#FF5E43" } : {}}
          className={`gap-1 border-top border-bottom border-1 rounded-1 ${
            isActive ? "text-white" : "text-danger pointer"
          }`}
        >
          <Col className="px-3 d-flex flex-row justify-content-between">
            <span>{val.label}</span>
            {isActive && (
              <ArrowCircleLeftOutlinedIcon style={{ color: "white" }} />
            )}
          </Col>
        </Row>
      </div>
    );
  };

  const handleOwlChange = async (e) => {
    setActiveIndex(e);
    setActiveDataModal(e);
    updateDataPolicyActive(e);
    setUpselectedAddress(e);
  };

  const handleConfrimSearch = () => {
    setActiveIndex(activeDataModal);
    updateDataPolicyActive(activeDataModal);
    handleCloseModal();
    setUpselectedAddress(activeDataModal);
  };

  const setUpselectedAddress = (index) => {
    setSelectedAddress((prev) => {
      let findAddress = prev.find((i) => i.id === addressData[index].id);
      if (findAddress) {
        return prev.filter((ii) => ii.id !== findAddress.id);
      } else {
        return [...prev, addressData[index]];
      }
    });
  };

  const CustomCheckbox = styled(Checkbox)({
    color: "rgba(255, 94, 67, 0.5)",
    "&.Mui-checked": {
      color: "#FF5E43",
    },
    marginRight: "15px",
  });

  const ScrollableCardInformation = () => {
    const cardRef = React.useRef(null);

    // const handlers = useSwipeable({
    //   onSwiped: (eventData) => {
    //     if (cardRef.current) {
    //       cardRef.current.scrollTop += -eventData.deltaY; // เลื่อนการ์ดตามการสไวป์ (ขึ้นหรือลง)
    //     }
    //   },
    //   delta: 10, // กำหนดความไวต่อการสไวป์
    //   trackMouse: true, // ทำให้ใช้เมาส์ในการลากได้
    // });

    const getEffectiveRaw = (x) =>
      x?.policyEffectiveDate ??
      x?.policy_effective_date ??
      x?.policy_effective ??
      x?.effectiveDate ??
      x?.effective_date ??
      null;
    
    const parseThaiAwareDate = (raw) => {
      if (!raw) return Number.POSITIVE_INFINITY;
    
      // Date instance
      if (raw instanceof Date) return raw.getTime();
    
      // Number timestamp หรือ YYYYMMDD เป็นตัวเลข
      if (typeof raw === "number") return new Date(raw).getTime();
    
      if (typeof raw === "string") {
        const s = raw.trim();
    
        // เคส YYYYMMDD (เช่น 20250831 หรือ 25680901)
        if (/^\d{8}$/.test(s)) {
          const y = parseInt(s.slice(0, 4), 10);
          const m = parseInt(s.slice(4, 6), 10);
          const d = parseInt(s.slice(6, 8), 10);
          let year = y > 2400 ? y - 543 : y;
          return new Date(year, m - 1, d).getTime();
        }
    
        // เคส ISO / เดาได้โดย Date.parse
        const iso = Date.parse(s);
        if (!Number.isNaN(iso)) {
          // ถ้าเป็นปี พ.ศ. ในรูป "2568-09-01" Date.parse จะ fail ในบางกรณี
          // แก้เพิ่ม: ถ้าปี > 2400 แปลงก่อน
          const y = parseInt(s.slice(0, 4), 10);
          if (y > 2400) {
            const fixed = (y - 543) + s.slice(4);
            const fixedTs = Date.parse(fixed);
            return Number.isNaN(fixedTs) ? Number.POSITIVE_INFINITY : fixedTs;
          }
          return iso;
        }
    
        // เคส DD/MM/YYYY หรือ DD-MM-YYYY
        const m1 = s.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
        if (m1) {
          let [, dd, mm, yyyy] = m1;
          let year = parseInt(yyyy, 10);
          const month = parseInt(mm, 10) - 1;
          const day = parseInt(dd, 10);
          if (year > 2400) year -= 543; // พ.ศ. → ค.ศ.
          return new Date(year, month, day).getTime();
        }
      }
    
      return Number.POSITIVE_INFINITY; // ไม่มี/พาร์สไม่ได้ → ดันไปท้าย
    };
    
    const compareByEffective = (a, b) => {
      const ta = parseThaiAwareDate(getEffectiveRaw(a));
      const tb = parseThaiAwareDate(getEffectiveRaw(b));
      if (ta !== tb) return ta - tb;
      // กันสลับ: ผูกด้วย policy_no ถ้ามี
      return String(a?.policy_no ?? "").localeCompare(String(b?.policy_no ?? ""));
    };

    return (
      <>
        <Box
          sx={{
            display: addressStep === 3 ? "flex" : "none",
            alignItems: "center",
          }}
          style={{ marginBottom: "10px" }}
        >
          <AssignmentTurnedInRoundedIcon
            fontSize="large"
            style={{ color: "rgb(255, 94, 67)" }}
          />
          <Typography style={{ fontSize: "20px", marginLeft: "10px" }}>
            ยืนยันข้อมูล
          </Typography>
        </Box>

        <Card
          sx={{
            maxHeight: "490px",
            overflowY: "hidden",
            border: "1px solid rgba(255, 94, 67, 0.3)",
            borderRadius: "12px",
            borderWidth: "2px",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          ref={cardRef}
        >
          <CardContent
            sx={{
              cursor: "pointer",
              overflowY: "auto",
              boxSizing: "border-box",
            }}
          >
            <List sx={styleDrive} style={{ marginBottom: "10px" }}>
              <ListItem>
                <ListItemText primary="กรุณาตรวจสอบข้อมูล" />
              </ListItem>
              <Divider variant="middle" component="li" />
            </List>

            {[...listData].sort(compareByEffective).map((_, index) => (
                <Box
                  key={_.policy_no ?? index}
                  sx={{
                    marginBottom: "15px",
                    padding: "10px",
                    transition: "background-color 0.3s ease, border 0.3s ease",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Card>
                    <CardHeader
                      title={"กรมธรรม์เลขที่ : " + _.policy_no}
                      sx={{
                        backgroundColor: "rgba(255, 94, 67, 0.3)",
                      }}
                      titleTypographyProps={{
                        sx: {
                          fontFamily: '"Prompt-Thin", sans-serif !important',
                          fontSize: "15px",
                          color: "black",
                          marginLeft: "15px",
                        },
                      }}
                    />
                    <CardContent style={{ marginBottom: "0px" }}>
                      <Typography>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={12} md={2} lg={3} xl={3}>
                            <span className="font-size-label-pol">
                              ที่อยู่ :
                            </span>
                          </Grid>
                          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                            <span className="font-size-label-pol2">
                              {_.addressType?.description &&
                                _.addressType?.description !== "-" &&
                                `ประเภทที่อยู่ ${_.addressType.description} `}
                              {_.place && _.place !== "-" && `${_.place} `}
                              {_.number &&
                                _.number !== "-" &&
                                `เลขที่ ${_.number} `}
                              {_.floor && _.floor !== "-" && `ชั้น ${_.floor} `}
                              {_.zone && _.zone !== "-" && `โซน ${_.zone} `}
                              {_.village &&
                                _.village !== "-" &&
                                `หมู่บ้าน ${_.village} `}
                              {_.building &&
                                _.building !== "-" &&
                                `อาคาร ${_.building} `}
                              {_.buildingNo &&
                                _.buildingNo !== "-" &&
                                `อาคารเลขที่ ${_.buildingNo} `}
                              {_.moo && _.moo !== "-" && `หมู่ที่ ${_.moo} `}
                              {_.soi && _.soi !== "-" && `ซอย ${_.soi} `}
                              {_.street &&
                                _.street !== "-" &&
                                `ถนน ${_.street} `}
                              {_.kwang?.name &&
                                _.kwang.name !== "-" &&
                                `แขวง/ตำบล ${_.kwang.name} `}
                              {_.khet?.name &&
                                _.khet.name !== "-" &&
                                `เขต/อำเภอ ${_.khet.name} `}
                              {_.province?.name &&
                                _.province.name !== "-" &&
                                `จังหวัด ${_.province.name} `}
                              {_.zip &&
                                _.zip !== "-" &&
                                `รหัสไปรษณีย์ ${_.zip}`}
                              {_.country?.name &&
                                _.country.name !== "-" &&
                                ` ประเทศ ${_.country.name}`}
                            </span>
                          </Grid>
                        </Grid>
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              ))}
          </CardContent>
        </Card>
      </>
    );
  };

  useEffect(() => {
    getPolicyInformation();
    getAddrType();
  }, []);

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getPolicyInformation = async () => {
    const result = await getPolicyInformationAPI(
      decryptCardNumber(insureIdCard, process.env.REACT_APP_ENCRYPT_DATA)
    );
    if (result.status) {
      let option = [];
      await result.data.policies.map((item, idx) => {
        let data = {
          label: item.policyNo,
          id: idx,
        };
        option.push(data);
      });

      setDataPolicy(result.data.policies);
      await setOption(option);
    }
  };

  const resendOtp = () => {
    handleReqOtp();
  };

  const notifySuccess = (title) => {
    toast.success(title, {
      position: "top-center",
    });
  };

  const notifyError = (title) => {
    toast.error(title, {
      position: "top-center",
    });
  };

  const handleReqOtp = async () => {
    const resultReqOtp = await requestOtpAPI("EDIT_ADDRESS");
    if (resultReqOtp.status === true) {
      notifySuccess(resultReqOtp.meg);
    } else {
      notifyError(resultReqOtp.meg);
    }
  };

  const getAddrType = async () => {
    const result = await getParameterAPI(28);
    if (result?.payload) {
      const sorted = [...result.payload].sort((a, b) => a.pmdId - b.pmdId);
      setAddrTypeOptions(sorted);
      console.log(sorted);
    }
  };

  return (
    <div className="edit-address">
      {loading ? (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={loading}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      ) : null}
      <Header_Home />
      <Header title="เปลี่ยนที่อยู่" />
      <div className="container-footer-space">
        <section
          className="update-receiving-address"
          style={{ display: addressStep === 1 ? "block" : "none" }}
        >
          <div
            className="pb-2"
            style={{ display: addressStep === 1 ? "block" : "none" }}
          >
            <img
              className="address-icon"
              src={icon_address_pin}
              alt="address-icon"
            />
            <span className="bold">{"เปลี่ยนที่อยู่"}</span>
          </div>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              spacing={3}
              sx={{ maxWidth: 800, margin: "0 auto" }}
            >
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputAutocomplete
                  id="input-address-type"
                  label="ประเภทที่อยู่"
                  placeholder="ประเภทที่อยู่"
                  value={addressType}
                  onChange={(value) => {
                    setAddressType(value);
                    removeInputError("input-address-type");
                  }}
                  options={addrTypeOptions}
                  getOptionLabel={(option) => option.description}
                  isOptionEqualToValue={(option, value) =>
                    option.code === value.code
                  }
                  error={inputErrors.includes("input-address-type")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-place"
                  label="สถานที่"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={place}
                  onChange={(e) => {
                    setPlace(e.target.value);
                    removeInputError("input-place");
                  }}
                  error={inputErrors.includes("input-place")}
                  inputProps={{
                    style: { fontSize: "16px" },
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-address-number"
                  label="เลขที่"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={addressNumber}
                  onChange={(e) => {
                    setAddressNumber(e.target.value); // ตรวจสอบว่าฟังก์ชันนี้อัปเดต state อย่างถูกต้อง
                  }}
                  error={inputErrors.includes("input-address-number")} // ลองทดสอบโดยคอมเมนต์ออกชั่วคราวเพื่อเช็คว่าเกี่ยวกับ error หรือไม่
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-floor"
                  label="ชั้น"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={floor}
                  onChange={(e) => {
                    setFloor(e.target.value); // ตรวจสอบว่าฟังก์ชันนี้อัปเดต state อย่างถูกต้อง
                    removeInputError("input-floor");
                  }}
                  error={inputErrors.includes("input-floor")} // ลองทดสอบโดยคอมเมนต์ออกชั่วคราวเพื่อเช็คว่าเกี่ยวกับ error หรือไม่
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-zone"
                  label="โซน"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={zone}
                  onChange={(e) => {
                    setZone(e.target.value); // ตรวจสอบว่าฟังก์ชันนี้อัปเดต state อย่างถูกต้อง
                    removeInputError("input-zone");
                  }}
                  error={inputErrors.includes("input-zone")} // ลองทดสอบโดยคอมเมนต์ออกชั่วคราวเพื่อเช็คว่าเกี่ยวกับ error หรือไม่
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-village"
                  label="หมู่บ้าน"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={village}
                  onChange={(e) => {
                    setVillage(e.target.value);
                    removeInputError("input-village");
                  }}
                  error={inputErrors.includes("input-village")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-building"
                  label="อาคาร"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={building}
                  onChange={(e) => {
                    setBuilding(e.target.value);
                    removeInputError("input-building");
                  }}
                  error={inputErrors.includes("input-building")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-building-no"
                  label="อาคารเลขที่"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={buildingNo}
                  onChange={(e) => {
                    setBuildingNo(e.target.value);
                    removeInputError("input-building-no");
                  }}
                  error={inputErrors.includes("input-buildin-no")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-moo"
                  label="หมู่ที่"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={moo}
                  onChange={(e) => {
                    setMoo(e.target.value);
                    removeInputError("input-moo");
                  }}
                  error={inputErrors.includes("input-moo")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-soi"
                  label="ซอย"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={soi}
                  onChange={(e) => {
                    setSoi(e.target.value);
                    removeInputError("input-soi");
                  }}
                  error={inputErrors.includes("input-soi")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-street"
                  label="ถนน"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={street}
                  onChange={(e) => {
                    setStreet(e.target.value);
                    removeInputError("input-street");
                  }}
                  error={inputErrors.includes("input-street")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputAutocomplete
                  id="input-province"
                  label="จังหวัด"
                  placeholder="กรุณาเลือก"
                  value={province}
                  onChange={(value) => {
                    // console.log("prev province value >>>", province);
                    // console.log("selected province value >>>", value);
                    if (!value) {
                      setKhet(null);
                      setKwang(null);
                      setZip(null);
                    } else {
                      if (province && value.id !== province.id) {
                        setKhet(null);
                        setKwang(null);
                        setZip(null);
                        setKhetOptions([]);
                        setKwangOptions([]);
                        setZipOptions([]);
                      }
                    }
                    setProvince(value);
                    removeInputError("input-province");
                  }}
                  options={provinceOptions || []}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  loading={loadingProvince}
                  error={inputErrors.includes("input-province")}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputAutocomplete
                  id="input-khet"
                  label="เขต/อำเภอ"
                  placeholder="กรุณาเลือก"
                  value={khet}
                  onChange={(value) => {
                    if (!value) {
                      setKwang(null);
                      setZip(null);
                    } else {
                      if (khet && value.id !== khet.id) {
                        setKwang(null);
                        setZip(null);
                        setKwangOptions([]);
                        setZipOptions([]);
                      }
                    }
                    setKhet(value);
                    removeInputError("input-khet");
                  }}
                  options={khetOptions || []}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disabled={!province}
                  loading={loadingKhet}
                  error={inputErrors.includes("input-khet")}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputAutocomplete
                  id="input-kwang"
                  label="แขวง/ตำบล"
                  placeholder="กรุณาเลือก"
                  value={kwang}
                  onChange={(value) => {
                    if (!value) {
                      setZip(null);
                    } else {
                      if (kwang && value.id !== kwang.id) {
                        setZip(null);
                        setZipOptions([]);
                      }
                    }
                    setKwang(value);
                    removeInputError("input-kwang");
                    removeInputError("input-zip"); // Note: also remove zip error because we loading new zip from selected Kwang
                  }}
                  options={kwangOptions || []}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  disabled={!khet}
                  loading={loadingKwang}
                  error={inputErrors.includes("input-kwang")}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-zip"
                  label="รหัสไปรษณีย์"
                  placeholder="รหัสไปรษณีย์"
                  value={zip}
                  onChange={(e) => {
                    setZip(e.target.value);
                    removeInputError("input-zip");
                  }}
                  disabled={!kwang}
                  loading={loadingZip}
                  error={inputErrors.includes("input-zip")}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputAutocomplete
                  id="input-country"
                  label="ประเทศ"
                  placeholder="กรุณาเลือก"
                  value={country}
                  onChange={(value) => {
                    setCountry(value);
                    removeInputError("input-country");
                  }}
                  options={countryOptions || []}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  loading={loadingCountry}
                  error={inputErrors.includes("input-country")}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6} md={6} lg={4} xl={4}>
                <CustomInputText
                  id="input-street"
                  label="ประเทศ"
                  placeholder="กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)"
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    removeInputError("input-street");
                  }}
                  error={inputErrors.includes("input-street")}
                  inputProps={{
                    style: { fontSize: "16px" }, // ขนาดตัวอักษรปกติ
                    placeholder: "กรณีไม่มีข้อมูล ให้ใส่เครื่องหมายขีดกลาง (-)",
                  }}
                  sx={{
                    "& ::placeholder": {
                      fontSize: "11px", // ขนาด placeholder เล็กลง
                    },
                  }}
                />
              </Grid> */}
            </Grid>
          </Box>
        </section>
        <br />
        {/* (addressStep === 2 :? ) <ScrollableCard /> */}

        {addressStep == 1 ? (
          <ScrollableCard
            listData={listData}
            addressData={addressData}
            setListData={setListData}
            addressType={addressType}
            place={place}
            addressNumber={addressNumber}
            building={building}
            village={village}
            moo={moo}
            soi={soi}
            province={province}
            khet={khet}
            kwang={kwang}
            zip={zip}
            street={street}
            floor={floor}
            zone={zone}
            buildingNo={buildingNo}
            country={country}
            dataPolicy={dataPolicy}
          />
        ) : addressStep == 3 ? (
          <ScrollableCardInformation />
        ) : addressStep == 4 ? (
          <Box sx={{ p: 1, margin: "auto" }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                mb: 2,
                display: "flex",
                alignItems: "center",
                fontFamily: "Prompt-Thin",
              }}
            >
              <VerifiedUserIcon sx={{ color: "#FF5E43", mr: 1 }} />
              ยืนยัน OTP
            </Typography>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 3,
                p: 3,
                mb: 3,
                textAlign: "center",
              }}
            >
              <Typography sx={{ mb: 2, textAlign: "left" }}>
                กรุณาใส่หมายเลข OTP 6 หลัก
                <br />
                ที่ส่งไปยังเบอร์มือถือของท่าน
              </Typography>
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="OTP"
                maxLength={6}
                value={otp}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setOtp(onlyNums);
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "30px",
                  border: "1px solid #ccc",
                  fontSize: 18,
                  width: "100%",
                  outline: "none",
                  marginBottom: 8,
                }}
              />

              <div
                style={{
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "flex-start", // ✅ ให้ชิดซ้าย
                  width: "100%",
                  marginTop: 10,
                }}
              >
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }} // ✅ กันพลาดเพิ่ม textAlign ด้วย
                >
                  ส่งรหัสผ่านไปที่หมายเลข{" "}
                  {localStorage.getItem("mobile_tel")
                    ? localStorage
                        .getItem("mobile_tel")
                        .replace(/(\d{3})(\d{4})(\d{3})/, "$1xxxx$3")
                    : ""}
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรณีไม่ได้รับหรือเปลี่ยนหมายเลขโทรศัพท์มือถือ
                </div>
                <div
                  className="font-size-content-otp"
                  style={{ fontSize: "14px", textAlign: "left" }}
                >
                  กรุณา
                  <span
                    onClick={() => setOpenContactModal(true)}
                    style={{
                      color: "#FF5E43",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    ติดต่อฝ่ายลูกค้าสัมพันธ์
                  </span>
                </div>
              </div>

              <Typography
                sx={{
                  color: "#f2654e",
                  fontSize: 14,
                  mt: 1,
                  cursor: "pointer",
                  textAlign: "left",
                }}
                onClick={resendOtp}
              >
                ส่งรหัส OTP อีกครั้ง?
              </Typography>
            </Paper>
          </Box>
        ) : (
          // ✅ อัพโหลดไฟล์
          <section className="upload-image-address">
            <div className={`address-image-card`}>
              <ul className="list-group list-group-flush">
                <div className="address-card-title">{"อัพโหลดไฟล์"}</div>
                <hr className="line" />
                <FileUploadWithPreviewAddress
                  setFiles={setFiles}
                  fileDescriptions={fileDescriptions}
                  files={files}
                />
              </ul>
            </div>
          </section>
        )}

        <br />
        <section className="action-address">
          <Grid
            container
            spacing={2}
            justifyContent="center" // จัดตำแหน่งตรงกลางแนวนอน
            alignItems="center" // จัดตรงกลางแนวตั้ง
            sx={{ minHeight: "10vh" }} // ให้ Grid เต็มความสูงหน้าจอ
          >
            <Grid item xs={12} sm={6} md={2}>
              <button
                onClick={() => {
                  if (addressStep === 1) {
                    navigate(-1); // ย้อนกลับหน้า
                  } else if (addressStep === 3 && idnvFlag == "Y") {
                    setAddressStep(addressStep - 2);
                  } else {
                    setAddressStep(addressStep - 1);
                  }
                }}
                className="btn-address-back w-100 p-2 bold"
              >
                ย้อนกลับ
              </button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <button
                style={{ fontSize: 18 }}
                onClick={() => {
                  if (addressStep <= 2) {
                    let errorsAddress = validateAddress();
                    if (errorsAddress.length === 0) {
                      if (listData.length === 0) {
                        setToggleImg(false);
                        setTextModal(
                          "กรุณาเลือกกรมธรรม์ที่ต้องการแจ้งเปลี่ยนที่อยู่"
                        );
                        setCompletedModal(true);
                        // refCarousel.current.scrollIntoView();
                      } else if (addressStep == 1 && idnvFlag == "N") {
                        // console.log("selectedAddress value 2", selectedAddress);
                        setAddressStep(2);
                      } else if (addressStep == 1 && idnvFlag == "Y") {
                        // console.log("selectedAddress value 2", selectedAddress);
                        setAddressStep(3);
                      } else if (addressStep == 2) {
                        const errorImage = validateImage();

                        if (!errorImage) {
                          setAddressStep(3);
                        }
                        // setAddressStep(3);
                      }
                    }
                  } else if (addressStep == 3) {
                    setAddressStep(4);
                    handleReqOtp();
                  } else if (addressStep === 4) {
                    saveAddressAndImage();
                  }
                }}
                className="btn-address-next w-100 p-2 bold"
              >
                {addressStep === 1 || addressStep === 2 || addressStep === 3
                  ? "ต่อไป"
                  : "บันทึก"}
              </button>
            </Grid>
          </Grid>
        </section>
      </div>
      <Modal
        isOpen={openModal}
        onRequestClose={handleCloseModal}
        contentLabel="ModalPolicy"
        className="Modal"
        overlayClassName="Overlay"
      >
        <div className="p-lg-2 p-3">
          <h3 style={{ color: "#FA0E0E", fontSize: "18px" }}>กรมธรรม์เลขที่</h3>
          <div className="d-grid mb-4">
            <TextField
              type="text"
              size="small"
              onChange={(e) => handleSearchBasePolicy(e.target.value)}
              className=""
              value={searchBasePolicy}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <img src={iconSearch} height={20} width={20} alt="" />
                  </InputAdornment>
                ),
              }}
              sx={{
                backgroundColor: "#FFF",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "6px",
                  height: "35px",
                  "& fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&:hover fieldset": {
                    borderColor: "#FB5E3F",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#FB5E3F",
                  },
                },
              }}
            />
          </div>
          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {!filteredOptions.length == 0 ? (
              filteredOptions.map(renderOptionRow)
            ) : (
              <div className="text-center text-muted">
                ไม่มีข้อมูลที่ตรงกับการค้นหา
              </div>
            )}
          </div>
          <Row className="d-flex flex-row justify-content-evenly mt-3">
            {/* <Col className="bg-danger"> */}
            <button
              style={{ fontSize: 15 }}
              onClick={handleConfrimSearch}
              className="btn-checkout-premium w-25 p-2 bold"
            >
              ตกลง
            </button>
            <button
              style={{ fontSize: 15 }}
              onClick={handleCloseModal}
              className="btn-checkout-back w-25 p-2 bold"
            >
              ยกเลิก
            </button>
          </Row>
        </div>
      </Modal>
      {/* <div className="backdrop"></div> */}
      {/* <Modal isOpen={false} className="Modal" overlayClassName="Overlay">
        <div className="modal-container">
          <img
            src={greenCheck}
            alt="check-icon"
            style={{ width: "150px", height: "150px" }}
          />
          <div
            style={{
              marginTop: 20,
              textAlign: "center",
            }}
          >
            {
              "บริษัทได้รับทราบข้อมูลจากท่านแล้ว ท่านจะได้รับ SMS เพื่อดาวน์โหลดเอกสารการเปลี่ยนแปลงภายใน 5 วันทำการ ขอบคุณค่ะ"
            }
          </div>
        </div>
      </Modal> */}
      <BootstrapModal
        show={completedModal}
        backdrop="static"
        // size="md"
        // style={{}}
        className="backdrop-alert"
        contentClassName="modal-alert"
      >
        <BootstrapModal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={toggleImg ? greenCheck : remove}
              alt="check-icon"
              className="modal-image-size"
            />
          </div>

          <li
            className="body-list-group"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col
              xl={12}
              md={12}
              xs={12}
              style={{
                display: "flex",
                marginTop: 5,
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <div className="font-modal">{textModal}</div>
            </Col>
          </li>
          <div className="d-flex justify-content-center flex-wrap">
            <button
              className="btn-checkout-modal w-20 p-2 bold"
              onClick={() => {
                if (toggleImg) {
                  navigate("/personal");
                } else {
                  setCompletedModal(false);
                }
              }}
            >
              กลับ
            </button>
          </div>
        </BootstrapModal.Body>
      </BootstrapModal>
      <ContactModal
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
      />
    </div>
  );
};

export default EditAddress2;
